/**
 * Shared Medical & Safety field defs for MedicalSafetyTab + PaperPacketIntakePanel.
 */

export const SEVERITY_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'mild', label: 'Mild' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'severe', label: 'Severe' },
  { value: 'life_threatening', label: 'Life-threatening' },
];

export const CONDITION_FIELDS = [
  { key: 'has_visual_impairment', label: 'Visual impairment' },
  { key: 'wears_glasses', label: 'Wears glasses' },
  { key: 'has_ear_infection', label: 'Ear infection' },
  { key: 'has_ear_tubes', label: 'Ear tubes' },
  { key: 'has_hearing_impairment', label: 'Hearing impairment' },
  { key: 'has_seizure_disorder', label: 'Seizure disorder' },
  { key: 'has_gtube', label: 'G-tube' },
  { key: 'has_asthma', label: 'Asthma' },
  { key: 'has_respiratory_compromise', label: 'Respiratory compromise' },
  { key: 'has_cardiac_compromise', label: 'Cardiac compromise' },
  { key: 'has_skin_condition', label: 'Skin condition' },
  { key: 'has_dental_condition', label: 'Dental condition' },
  { key: 'has_tracheostomy', label: 'Trach (tracheostomy)' },
];

export const EMPTY_PROFILE = () => ({
  has_visual_impairment: false,
  wears_glasses: false,
  has_ear_infection: false,
  has_ear_tubes: false,
  has_hearing_impairment: false,
  has_seizure_disorder: false,
  has_gtube: false,
  has_asthma: false,
  has_respiratory_compromise: false,
  has_cardiac_compromise: false,
  has_skin_condition: false,
  has_dental_condition: false,
  has_tracheostomy: false,
  medications_text: '',
  other_medical_notes: '',
  food_from_home: '',
  liquid_type: '',
  emergency_action_plan: '',
});

export const EMPTY_ALLERGY = (order = 1) => ({
  allergen: '',
  severity: '',
  reacts_to_eat: false,
  reacts_to_touch: false,
  reacts_to_smell: false,
  reaction_description: '',
  requires_anaphylaxis_plan: false,
  order,
  _new: true,
});

/** Confidence below this is flagged for staff review in the intake panel. */
export const OCR_LOW_CONFIDENCE = 0.7;

export const INTAKE_SOURCE_HEADER = 'X-Intake-Source';
export const INTAKE_SOURCE_PAPER_OCR = 'paper_ocr_intake';
